export const SANITIZE_OPTIONS = {
  allowedAttributes: {
    '*': ['class', 'id'],
    a: ['href', 'title', 'target'],
    img: ['src', 'alt'],
    div: ['data-message'],
  },
}
